import axios from "axios";
import environment from "../constants/environments";
import storageKeys from "src/constants/storage";
import { getFromStorage } from "./storage";
import { logoutAndRedirect } from "./auth";

export const METHODS = {
  GET: "GET",
  POST: "POST",
  PUT: "PUT",
  DELETE: "DELETE",
  PATCH: "PATCH",
} as const;

const request = async ({
  route,
  method = METHODS.GET,
  payload = {},
  params = {},
  auth = false,
  isAdminAuth = false,
}: {
  route: string;
  method?: "GET" | "POST" | "PUT" | "DELETE" | "PATCH";
  payload?: any;
  params?: any;
  auth?: boolean;
  isAdminAuth?: boolean;
}) => {
  const stringifiedParams = new URLSearchParams(params).toString();
  if (stringifiedParams) {
    route += `?${stringifiedParams}`;
  }
  const url = `${environment.apiBaseUrl}${route}`;

  let authToken = null;

  if (auth) {
    const authTokenKey = isAdminAuth
      ? storageKeys.authAdminToken
      : storageKeys.authTenantToken;
    authToken = getFromStorage(authTokenKey);
    // if (!authToken) {
    //   throw new Error("Authentication token not found");
    // }
  }

  try {
    const response = await axios(url, {
      method,
      headers: {
        "Content-Type": "application/json",
        ...(authToken ? { Authorization: `Bearer ${authToken}` } : {}),
      },
      data: JSON.stringify(payload),
    });

    if (response.status >= 200 && response.status < 300) {
      return response.data;
    } else {
      throw new Error(response.statusText);
    }
  } catch (error: any) {
    if (error?.response?.status === 401) {
      logoutAndRedirect({ isAdmin: isAdminAuth });
    }
    console.error("API request error:", error);
    throw new Error(
      error.response?.data?.message || error.message || "API request failed"
    );
  }
};

export default request;
